import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { V2_BASE } from '../config';
import {
  Home, ChevronRight, Headphones, HelpCircle, Mail, Phone, MessageCircle,
  Calendar, Clock, Lock, X, Info, Ticket, Sparkles,
} from 'lucide-react';
import './contabilita.css';
import './support.css';

const api = axios.create({ withCredentials: true });
const fmtDate = (d) => { if (!d) return '—'; try { return new Date(d).toLocaleDateString('it-IT', { day: '2-digit', month: 'short', year: 'numeric' }); } catch { return '—'; } };

/* ── Modal ── */
const Modal = ({ title, onClose, children, desc }) => (
  <div className="nfx-modal-scrim" onClick={onClose}>
    <div className="nfx-modal" onClick={e => e.stopPropagation()}>
      <div className="nfx-modal__head">
        <span className="nfx-modal__title">{title}</span>
        <button className="nfx-modal__close" onClick={onClose} aria-label="Chiudi"><X size={20} /></button>
      </div>
      <div className="nfx-modal__body">
        {desc && <div className="nfx-modal__desc">{desc}</div>}
        {children}
      </div>
    </div>
  </div>
);

const SupportoPage = () => {
  const navigate = useNavigate();
  const [tickets, setTickets] = useState([]);
  const [modal, setModal] = useState(null); // 'contact' | 'tickets' | null

  useEffect(() => {
    api.get('/api/support/tickets').then(r => setTickets(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, []);

  const openTicket = () => { setModal(null); navigate(V2_BASE + '/support'); };

  return (
    <div className="nfx-sup">
      {/* Breadcrumb */}
      <div className="nfx-crumb">
        <button className="nfx-crumb__home" onClick={() => navigate(V2_BASE)} aria-label="Home"><Home size={16} /></button>
        <span className="nfx-crumb__sep"><ChevronRight size={15} /></span>
        <span className="nfx-crumb__cur"><Headphones size={15} style={{ verticalAlign: '-2px', marginRight: 6 }} />Supporto</span>
      </div>

      {/* Header */}
      <div className="nfx-sup-head">
        <div className="nfx-sup-head__l">
          <span className="nfx-sup-head__ic"><Headphones size={24} /></span>
          <span className="nfx-sup-head__title">Supporto</span>
        </div>
        <button className="nfx-sup-faq" onClick={() => window.open('https://docs.neoflux.it', '_blank')}>
          <HelpCircle size={16} /> Consulta le FAQ
        </button>
      </div>

      {/* Premium banner */}
      <div className="nfx-sup-banner">
        <div className="nfx-sup-banner__top">
          <span className="nfx-sup-banner__ic"><Sparkles size={26} /></span>
          <span className="nfx-sup-banner__title">Servizio di assistenza Premium</span>
        </div>
        <div className="nfx-sup-banner__desc">Per saperne di più sulle nostre offerte di supporto per organizzazioni e sviluppatori.</div>
        <div className="nfx-sup-banner__feats">
          <span>7gg/7</span><span>Risposta prioritaria</span><span>Chiamate urgenti 24/7</span><span>Consulenze personalizzate</span>
        </div>
        <button className="nfx-sup-banner__btn" onClick={() => window.open('https://neoflux.it', '_blank')}>Scopri il Servizio di assistenza Premium</button>
      </div>

      {/* Contact */}
      <div className="nfx-sup-contact">
        <div>
          <div className="nfx-sup-contact__t">Contatta i nostri team tramite chat, e-mail o telefono</div>
          <div className="nfx-sup-contact__d">Bisogno di aiuto? Siamo a tua completa disposizione.</div>
        </div>
        <button className="nfx-btn-blue" onClick={() => setModal('contact')}>Contattare l'assistenza</button>
      </div>

      {/* Two cards */}
      <div className="nfx-sup-grid">
        <div className="nfx-sup-card">
          <div className="nfx-sup-card__top">
            <div>
              <div className="nfx-sup-card__title">Ticket
                <span className="nfx-sup-card__status" style={{ color: '#d64530' }}><span className="nfx-sup-card__dot" style={{ background: '#d64530' }} /> Centrale chiusa</span>
              </div>
              <div className="nfx-sup-card__meta"><span><Calendar size={16} /> 7 g./7</span><span><Clock size={16} /> da 06h00 a 23h00</span></div>
            </div>
            <span className="nfx-sup-card__illu"><Mail size={26} /></span>
          </div>
          <div className="nfx-sup-card__sep" />
          <div className="nfx-sup-card__sub">Tempi di risposta rapidi <Info size={15} color="#9f9f9f" /></div>
          <button className="nfx-sup-card__link" onClick={() => setModal('tickets')}>Le mie richieste{tickets.length ? ` (${tickets.length})` : ''}</button>
        </div>

        <div className="nfx-sup-card">
          <div className="nfx-sup-card__top">
            <div>
              <div className="nfx-sup-card__title">Chiamata
                <span className="nfx-sup-card__status" style={{ color: '#d64530' }}><span className="nfx-sup-card__dot" style={{ background: '#d64530' }} /> Centrale chiusa</span>
              </div>
              <div className="nfx-sup-card__meta"><span><Calendar size={16} /> 5 g./7</span><span><Clock size={16} /> da 09:00 a 18:00</span></div>
            </div>
            <span className="nfx-sup-card__illu"><Headphones size={26} /></span>
          </div>
        </div>
      </div>

      {/* Accessi rapidi */}
      <div className="nfx-sup-quick">
        <div className="nfx-sup-quick__title">Accessi rapidi</div>
        <div className="nfx-sup-quick__row">
          <span className="nfx-sup-quick__ic"><Lock size={18} /></span>
          <div>
            <div className="nfx-sup-quick__k">Codice di autorizzazione <Info size={14} color="#9f9f9f" /></div>
            <button className="nfx-sup-quick__link" onClick={() => navigate(V2_BASE + '/account/supporto')}>Concedi l'accesso al servizio di assistenza</button>
          </div>
        </div>
      </div>

      {/* ── Modali ── */}
      {modal === 'contact' && (
        <Modal title="Contattare l'assistenza" onClose={() => setModal(null)}
          desc="Scegli il canale più adatto: ti risponderemo il prima possibile.">
          <div className="nfx-chan">
            <button className="nfx-chan__item" onClick={openTicket}>
              <span className="nfx-chan__ic" style={{ background: '#1d3c51' }}><MessageCircle size={20} /></span>
              <span className="nfx-chan__t"><b>Livechat</b><span>Chatta in tempo reale con un operatore</span></span>
              <ChevronRight size={18} color="#9f9f9f" />
            </button>
            <button className="nfx-chan__item" onClick={openTicket}>
              <span className="nfx-chan__ic" style={{ background: '#3b5e49' }}><Mail size={20} /></span>
              <span className="nfx-chan__t"><b>Crea un ticket</b><span>Apri una richiesta via e-mail</span></span>
              <ChevronRight size={18} color="#9f9f9f" />
            </button>
            <button className="nfx-chan__item" onClick={() => { window.location.href = 'tel:+390000000000'; }}>
              <span className="nfx-chan__ic" style={{ background: '#1d3c51' }}><Phone size={20} /></span>
              <span className="nfx-chan__t"><b>Chiamaci</b><span>Dal lunedì al venerdì, 09:00–18:00</span></span>
              <ChevronRight size={18} color="#9f9f9f" />
            </button>
          </div>
        </Modal>
      )}

      {modal === 'tickets' && (
        <Modal title="Le mie richieste" onClose={() => setModal(null)}
          desc={tickets.length ? `${tickets.length} richiesta/e` : undefined}>
          {tickets.length === 0 ? (
            <div className="nfx-empty2" style={{ padding: '28px 0' }}>
              <span className="nfx-empty2__icon"><Ticket size={36} /></span>
              <div className="nfx-empty2__title">Nessuna richiesta</div>
              <button className="nfx-btn-blue" style={{ marginTop: 8 }} onClick={openTicket}>Crea una richiesta</button>
            </div>
          ) : (
            <div>
              {tickets.slice(0, 8).map((t, i) => (
                <div className="nfx-mt-row" key={t.id || i} onClick={openTicket}>
                  <span className="nfx-mt-ic"><Ticket size={16} /></span>
                  <span className="nfx-mt-main">
                    <span className="nfx-mt-name">{t.oggetto || t.titolo || '—'}</span>
                    <span className="nfx-mt-sub">#{t.numero || String(t.id).slice(0, 8)} · {fmtDate(t.creato_il || t.created_at)}</span>
                  </span>
                  <ChevronRight size={16} color="#9f9f9f" />
                </div>
              ))}
            </div>
          )}
        </Modal>
      )}
    </div>
  );
};

export default SupportoPage;
